import CellLink from '@/components/GokuDataGrid/CellLink'
import CellStatus, { Color } from '@/components/GokuDataGrid/CellStatus'
import CellDate from '@/components/GokuDataGrid/CellDate'
import { Reseller } from '@/modules/Reseller/types'
import { generatePathDatacentral, paths } from '@/utils/path'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { Tooltip, Typogaphy } from 'vnetwork-ui'
import { TFunction } from 'i18next'
import {
    RESELLER_STATUS_OPTIONS,
    RESELLER_TIER_OPTIONS,
} from '@/modules/Reseller/constants'

export const resellerListColumns = (
    t: TFunction
): GridColDefVNW<Reseller>[] => [
    {
        field: 'reseller_name',
        headerName: t('reseller_name'),
        sortable: true,
        renderCell: ({ row }) => (
            <CellLink
                to={generatePathDatacentral(paths.resellerDetail, {
                    id: String(row?.reseller_id),
                })}
            >
                {row?.reseller_name}
            </CellLink>
        ),
        width: 250,
    },
    {
        field: 'customer',
        headerName: t('linked_customer'),
        sortable: false,
        renderCell: ({ row }) => (
            <Tooltip title={row?.customer?.customer_email || ''}>
                <Typogaphy>{row?.customer?.customer_name || '-'}</Typogaphy>
            </Tooltip>
        ),
        width: 200,
    },
    {
        field: 'reseller_tier',
        headerName: t('tier'),
        sortable: true,
        renderCell: ({ row }) => {
            const tier = RESELLER_TIER_OPTIONS(t)?.find(
                (item) => item?.value === row?.reseller_tier
            )

            return row?.reseller_tier ? (
                <CellStatus
                    label={tier?.label || row?.reseller_tier}
                    color={tier?.color as Color}
                    className="capitalize min-w-[80px]"
                />
            ) : (
                <Typogaphy>-</Typogaphy>
            )
        },
        width: 120,
    },
    {
        field: 'reseller_status',
        headerName: t('status'),
        sortable: true,
        renderCell: ({ row }) => {
            const status = RESELLER_STATUS_OPTIONS(t)?.find(
                (item) => item?.value === row?.reseller_status
            )

            return (
                <CellStatus
                    label={status?.label || row?.reseller_status}
                    color={status?.color as Color}
                    className="capitalize min-w-[80px]"
                />
            )
        },
        width: 120,
    },
    {
        field: 'organization_count',
        headerName: t('organizations'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>{row?.organization_count || 0}</Typogaphy>
        ),
        width: 120,
    },
    {
        field: 'created_at',
        headerName: t('created_at'),
        sortable: true,
        renderCell: ({ row }) => <CellDate date={row?.created_at} />,
        width: 150,
    },
]
